/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { Icon } from '../../internal/Icon';
import { MediaUiASkipForwardIcon16Light } from './MediaUiASkipForwardIcon16Light';
import { MediaUiASkipForwardIcon16Regular } from './MediaUiASkipForwardIcon16Regular';
import { MediaUiASkipForwardIcon16Solid } from './MediaUiASkipForwardIcon16Solid';
import { MediaUiASkipForwardIcon20Light } from './MediaUiASkipForwardIcon20Light';
import { MediaUiASkipForwardIcon20Regular } from './MediaUiASkipForwardIcon20Regular';
import { MediaUiASkipForwardIcon20Solid } from './MediaUiASkipForwardIcon20Solid';
import { MediaUiASkipForwardIcon24Regular } from './MediaUiASkipForwardIcon24Regular';
import { MediaUiASkipForwardIcon24Solid } from './MediaUiASkipForwardIcon24Solid';
import { MediaUiASkipForwardIcon32Regular } from './MediaUiASkipForwardIcon32Regular';
import { MediaUiASkipForwardIcon64Regular } from './MediaUiASkipForwardIcon64Regular';
var sizes = {
    16: {
        light: MediaUiASkipForwardIcon16Light,
        regular: MediaUiASkipForwardIcon16Regular,
        solid: MediaUiASkipForwardIcon16Solid,
    },
    20: {
        light: MediaUiASkipForwardIcon20Light,
        regular: MediaUiASkipForwardIcon20Regular,
        solid: MediaUiASkipForwardIcon20Solid,
    },
    24: {
        regular: MediaUiASkipForwardIcon24Regular,
        solid: MediaUiASkipForwardIcon24Solid,
    },
    32: {
        regular: MediaUiASkipForwardIcon32Regular,
    },
    64: {
        regular: MediaUiASkipForwardIcon64Regular,
    },
};
export var MediaUiASkipForwardIcon = forwardRef('MediaUiASkipForwardIcon', function (props, ref) {
    return React.createElement(Icon, __assign({ ref: ref }, props, { sizes: sizes }));
});
